import React, { useEffect, useState } from "react";
import ContentCard from "../common/contentCard";
import { fetchHtmlPageByName } from "../../services/htmlPageService";

const PssfGa = () => {
  const [htmlContent, setHtmlContent] = useState("");
  const [htmlContentFamilySupport, setHtmlContentFamilySupport] = useState("");
  const [htmlContentFamilyPreservation, setHtmlContentFamilyPreservation] =
    useState("");
  const [htmlContentFamilyReunification, setHtmlContentFamilyReunification] =
    useState("");
  const [htmlContentAdoptionPromotion, setHtmlContentAdoptionPromotion] =
    useState("");
  const [
    htmlContentSummaryAndRegionalProfile,
    setHtmlContentSummaryAndRegionalProfile,
  ] = useState("");
  const [htmlContentTabSummary, setHtmlContentTabSummary] = useState("");

  const [loading, setLoading] = useState(true); // Loading state
  const [error, setError] = useState(null); // Error state

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const [
          pssfga,
          familySupport,
          familyPreservation,
          familyReunification,
          adoptionPromotion,
          summary,
          tabSummary,
        ] = await Promise.all([
          fetchHtmlPageByName("pssfga"),
          fetchHtmlPageByName("pssfga-FamilySupportServices"),
          fetchHtmlPageByName("pssfga-FamilyPreservation"),
          fetchHtmlPageByName("pssfga-FamilyReunification"),
          fetchHtmlPageByName("pssfga-AdoptionPromotion"),
          fetchHtmlPageByName("pssfga-SummaryAndRegionalProfiles"),
          fetchHtmlPageByName("pssfga-TabSummary"),
        ]);

        setHtmlContent(pssfga.data.content);
        setHtmlContentFamilySupport(familySupport.data.content);
        setHtmlContentFamilyPreservation(familyPreservation.data.content);
        setHtmlContentFamilyReunification(familyReunification.data.content);
        setHtmlContentAdoptionPromotion(adoptionPromotion.data.content);
        setHtmlContentSummaryAndRegionalProfile(summary.data.content);
        setHtmlContentTabSummary(tabSummary.data.content);
      } catch (error) {
        console.error("Error fetching HTML page content:", error);
        setError("Failed to load content");
      } finally {
        setLoading(false);
      }
    };

    fetchContent();
  }, []);

  const onTabChange = (e, ElementId) => {
    let i, x, tablinks;
    const tab = document.getElementById(ElementId);

    x = document.getElementsByClassName("category");
    for (i = 0; i < x.length; i++) {
      x[i].classList.add("d-none");
    }

    tab.classList.remove("d-none");

    tablinks = document.getElementsByClassName("tab-link");
    for (i = 0; i < x.length; i++) {
      tablinks[i].classList.remove("tabbeddiv-custom-blue");
      tablinks[i].classList.remove("tabbeddiv-custom");
    }
    document.getElementById("tab" + e).classList.add("tabbeddiv-custom-blue");
  };

  if (loading) return <div>Loading...</div>; // Display loading indicator
  if (error) return <div>{error}</div>; // Display error message if any

  return (
    <div className="row justify-content-center">
      <div className="col-10">
        <div className="row mb-5">
          <div className="col-6">
            <div className="col mt-3 mb-5">
              <h2 className="text-center fw-bold">
                Network of Service and Supports
                <br /> for Families
              </h2>
            </div>
            <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
          </div>
          <div className="col-6 mt-3">
            <img
              src={require("../../img/pssfga_mom.png")}
              style={{ width: "97%", maxWidth: "calc(33.33% * 3)" }} // Matches width of 3 boxes
              alt="Mother Helping Daughter With Writing Color Letters In Notebook"
            />
          </div>
          <div
            className="row"
            d-flex
            justify-content-between
            style={{ marginTop: "20px" }}
          >
            <div className="col-4">
              <ContentCard
                header={"Our Vision"}
                body={
                  "Every child will be secure from abuse and neglect and become a healthy, literate, productive and economically self-sustaining citizen within a nurturing, caring, permanent home environment."
                }
              />
            </div>
            <div className="col-4">
              <ContentCard
                header={"Our Mission"}
                body={
                  "Strengthen Georgia families and remove barriers to child safety, permanency and well-being."
                }
              />
            </div>
            <div className="col-4">
              <ContentCard
                header={"Our Goals"}
                body={
                  "To achieve better outcomes for children and families by recruiting, training and sustaining and coordinated network of community-based, family-centered, outcomes-driven organizations."
                }
              />
            </div>
          </div>

          <div className="col mt-4">
            <div dangerouslySetInnerHTML={{ __html: htmlContentTabSummary }} />
          </div>
          <nav
            className="navbar navbar-expand-lg  tabbedNavbar-custom"
            style={{ padding: 0 }}
          >
            <div className="collapse navbar-collapse">
              <div
                className="navbar-nav nav-fill w-100"
                style={{ height: "60px" }}
              >
                <div
                  id="tab1"
                  className="nav-item nav-link tab-link border-end border-white col-3 tabbeddiv-custom-blue"
                  onClick={() => onTabChange(1, "support")}
                >
                  Family Support
                </div>
                <div
                  id="tab2"
                  className="nav-item nav-link tab-link border-end border-white col-3 tabbeddiv-custom"
                  onClick={() => onTabChange(2, "preservation")}
                >
                  Family Preservation
                </div>
                <div
                  id="tab3"
                  className="nav-item nav-link tab-link border-end border-white col-3 tabbeddiv-custom"
                  onClick={() => onTabChange(3, "reunification")}
                >
                  Family Reunification
                </div>
                <div
                  id="tab4"
                  className="nav-item nav-link tab-link col-3 tabbeddiv-custom"
                  onClick={() => onTabChange(4, "permanency")}
                >
                  Adoption Promotion and Post-Permanency
                </div>
              </div>
            </div>
          </nav>
          <div
            id="support"
            className="card category p-2"
            style={{ backgroundColor: "#ede7de" }}
          >
            <div
              dangerouslySetInnerHTML={{ __html: htmlContentFamilySupport }}
            />
          </div>
          <div
            id="preservation"
            className="card category p-2 d-none"
            style={{ backgroundColor: "#ede7de" }}
          >
            <div
              dangerouslySetInnerHTML={{
                __html: htmlContentFamilyPreservation,
              }}
            />
          </div>
          <div
            id="reunification"
            className="card category p-2 d-none"
            style={{ backgroundColor: "#ede7de" }}
          >
            <div
              dangerouslySetInnerHTML={{
                __html: htmlContentFamilyReunification,
              }}
            />
          </div>
          <div
            id="permanency"
            className="card category p-2 d-none"
            style={{ backgroundColor: "#ede7de" }}
          >
            <div
              dangerouslySetInnerHTML={{
                __html: htmlContentAdoptionPromotion,
              }}
            />
          </div>
          <div className="col-12">
            <div
              dangerouslySetInnerHTML={{
                __html: htmlContentSummaryAndRegionalProfile,
              }}
            />
          </div>
          <div className="row mb-4">
            <div className="col-3">
              <div
                className="card text-center p-3"
                style={{
                  backgroundColor: "#ede7de",
                  border: "1px solid #415868",
                }}
              >
                <strong>
                  <h6>2024:</h6>
                </strong>
                <a
                  href={require("../../docs/2024 PSSF in Georgia Infographics.pdf")}
                  target="_blank"
                  className="text-warning"
                  rel="noopener noreferrer"
                >
                  2024 Statewide Summary Profile
                </a>
              </div>
            </div>
            <div className="col-3 ">
              <div
                className="card text-center p-3"
                style={{
                  backgroundColor: "#ede7de",
                  border: "1px solid #415868",
                }}
              >
                <strong>
                  <h6>2021:</h6>
                </strong>
                <a
                  href={require("../../docs/2021 PSSF Network Infographic 032222.pdf")}
                  target="_blank"
                  className="text-warning"
                  rel="noopener noreferrer"
                >
                  2021 Statewide Summary Profile
                </a>
              </div>
            </div>
            <div className="col-3 ">
              <div
                className="card text-center p-3"
                style={{
                  backgroundColor: "#ede7de",
                  border: "1px solid #415868",
                }}
              >
                <strong>
                  <h6>2020:</h6>
                </strong>
                <a
                  href={require("../../docs/2020PSSFnetInfographic.pdf")}
                  target="_blank"
                  className="text-warning"
                  rel="noopener noreferrer"
                >
                  2020 Statewide Summary Profile
                </a>
              </div>
            </div>
            <div className="col-3 ">
              <div
                className="card text-center p-3"
                style={{
                  backgroundColor: "#ede7de",
                  border: "1px solid #415868",
                }}
              >
                <strong>
                  <h6>2019:</h6>
                </strong>
                <a
                  href={require("../../docs/2019PSSFnetInfographic.pdf")}
                  target="_blank"
                  className="text-warning"
                  rel="noopener noreferrer"
                >
                  2019 Statewide Summary Profile
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PssfGa;
